import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import * as echarts from 'echarts';
import dayjs from 'dayjs';
export default {
  name: 'device_history_analysis',
  props: {
    current: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '历史分析',
        queryFunName: 'smartControlTLogQuery',
        itemQueryFunName: 'smartControlItemQuery'
      },
      searchForm: {
        page: 1,
        limit: -1,
        sortField: 'ts',
        smartControlId: this.current.id
      },
      time: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
      item_list: [],
      checked: [],
      count: 0
    };
  },
  mounted: function mounted() {
    this.itemQuery();
  },
  destroyed: function destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    back: function back() {
      this.$emit('child-go-smartControl');
    },
    itemQuery: function itemQuery() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, _iterator, _step, item;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$api[_this.pageConfig.itemQueryFunName]({
                page: 1,
                limit: 50,
                smartControlId: _this.current.id
              });
            case 2:
              res = _context.sent;
              _this.item_list = [];
              _this.itemOptions = {};
              _this.checked = [];
              _iterator = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  if (item.valueType != 'Enums') {
                    _this.item_list.push(item);
                    _this.checked.push(item.typeCode);
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context.next = 10;
              return _this.query();
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    query: function query() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _iterator2, _step2, item, loading, res, _iterator3, _step3, _item, key, series, _iterator4, _step4, _item2, option;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 图表数据初始化
              _iterator2 = _createForOfIteratorHelper(_this2.item_list);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  item = _step2.value;
                  if (item.valueType != 'Enums') {
                    _this2.itemOptions[item.typeCode] = {
                      name: item.typeName,
                      type: 'line',
                      connectNulls: true,
                      // 连接缺失点
                      data: []
                    };
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              console.log('checked', _this2.checked);
              loading = _this2.$loading({
                lock: true,
                text: '数据加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              if (_this2.timer) {
                clearTimeout(_this2.timer);
              }
              _this2.timer = setTimeout(function () {
                loading.close();
              }, 60000);
              if (_this2.echarts) {
                _this2.echarts.clear();
              }
              _this2.echarts = echarts.init(document.getElementById('chart-container'));
              _context2.next = 10;
              return _this2.$api[_this2.pageConfig.queryFunName](_this2.current.id, _objectSpread(_objectSpread({}, _this2.searchForm), {}, {
                starDate: _this2.time[0],
                endDate: _this2.time[1]
              }));
            case 10:
              res = _context2.sent;
              if (_this2.timer) {
                clearTimeout(_this2.timer);
              }
              loading.close();
              _this2.count = res.data ? res.data.length : 0;
              _iterator3 = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  _item = _step3.value;
                  for (key in _this2.itemOptions) {
                    _this2.itemOptions[key].data.push([_item.ts, _item[key] || null]);
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              series = [];
              _iterator4 = _createForOfIteratorHelper(_this2.checked);
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  _item2 = _step4.value;
                  series.push(_this2.itemOptions[_item2]);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
              console.log('this.itemOptions', _this2.itemOptions);
              option = {
                color: ['#2788E1', '#DD4588', '#66DC95', '#502CF1', '#E0831A', '#8fd3e8', '#d95850'],
                tooltip: {
                  trigger: 'axis'
                },
                grid: {
                  bottom: 80
                },
                xAxis: {
                  type: 'time',
                  boundaryGap: false,
                  axisLabel: {
                    show: true,
                    rotate: 30,
                    textStyle: {
                      color: '#000'
                    }
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#094060'
                    }
                  }
                },
                yAxis: {
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: '#000'
                    }
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#094060'
                    }
                  },
                  type: 'value'
                },
                series: series
              };
              _this2.echarts.setOption(option);
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    search: function search() {
      if (!this.checked.length) {
        this.$message.info('请先选择设备参数');
        return;
      }
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : '^ts';
      this.query();
    }
  }
};